import { useEffect, useState } from 'react';

export default function HeroSection() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToServices = () => {
    const servicesSection = document.getElementById('services');
    if (servicesSection) {
      servicesSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollProgress = Math.min(scrollY / 800, 1);
  const heroOpacity = Math.max(0.2, 1 - scrollProgress * 0.8);
  const heroScale = Math.max(0.9, 1 - scrollProgress * 0.1);
  const contentTranslateY = scrollProgress * 50;

  return (
    <section 
      className="relative min-h-screen flex items-center justify-start overflow-hidden z-10"
      style={{
        backgroundColor: '#E7E5E4',
        backgroundImage: `url('https://static.readdy.ai/image/000745ea5477ac1971ad11ea6f2dc4d7/949b93026f71981d737f903e33cf3ccb.jpeg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        opacity: heroOpacity,
        transform: `scale(${heroScale})`,
        transition: 'opacity 0.1s ease-out, transform 0.1s ease-out'
      }}
    >
      <div className="absolute inset-0 bg-stone-900/40 z-10"></div>

      <div className="relative z-20 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          className="max-w-2xl"
          style={{
            transform: `translateY(${contentTranslateY}px)`,
            transition: 'transform 0.1s ease-out',
          }}
        >
          <div className="space-y-8">
            <div className="space-y-6">
              <div className="flex items-center space-x-4 mb-8">
                <div className="w-16 h-16 rounded-full border-3 border-stone-100 flex items-center justify-center bg-stone-100/10 backdrop-blur-sm overflow-hidden">
                  <img 
                    src="https://static.readdy.ai/image/000745ea5477ac1971ad11ea6f2dc4d7/288bdd613bb4bb3ca5113047b2fc0ce9.png" 
                    alt="Legal Findings and Studies Logo" 
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <h1 className="text-3xl font-light text-stone-100 tracking-wide">Legal Findings and Studies, Lda.</h1>
                  <p className="text-stone-200 font-light">Expert Legal Services</p>
                </div>
              </div>

              <h2 className="text-4xl lg:text-5xl xl:text-6xl font-light text-stone-100 leading-tight">
                Professional Legal Services with{' '}
                <span className="font-normal">Excellence</span>
              </h2>

              <p className="text-xl lg:text-2xl text-stone-200 leading-relaxed font-light max-w-xl">
                Dedicated legal expertise providing comprehensive solutions for your organization and personal needs.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-6">
              <button 
                onClick={scrollToContact}
                className="bg-stone-100 text-stone-900 px-10 py-5 text-lg font-medium hover:bg-stone-200 transition-colors whitespace-nowrap cursor-pointer rounded-full"
              >
                Schedule Consultation
              </button>
              <button 
                onClick={scrollToServices}
                className="px-10 py-5 text-lg font-light text-stone-100 border-2 border-stone-200/50 hover:border-stone-100 hover:bg-stone-100/10 transition-all whitespace-nowrap cursor-pointer rounded-full"
              >
                Our Services
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20"
        style={{
          opacity: Math.max(0, 1 - scrollProgress * 2),
          transition: 'opacity 0.2s ease-out',
        }}
      >
        <div className="flex flex-col items-center space-y-2">
          <span className="text-stone-200 text-sm font-light">
            Scroll to explore
          </span>
          <div className="w-6 h-10 border-2 border-stone-200/30 rounded-full flex justify-center">
            <div className="w-1 h-3 bg-stone-200/50 rounded-full mt-2 animate-bounce"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
